import { config } from 'config';

const base = config.apiBaseUrl;

export interface User {
  id: string;
  login: string;
}

function getJson<T>(res: Response): Promise<T> {
  if (!res.ok) {
    return res.json().then(
      (body: { message?: string; code?: string }) => {
        throw new Error(body.message ?? `HTTP ${res.status}`);
      },
      () => {
        throw new Error(`HTTP ${res.status}`);
      }
    );
  }
  if (res.status === 204) return Promise.resolve(undefined as T);
  return res.json();
}

export async function login(login: string, password: string): Promise<User> {
  const res = await fetch(`${base}/auth/login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify({ login, password }),
  });
  return getJson<User>(res);
}

export async function logout(): Promise<void> {
  const res = await fetch(`${base}/auth/logout`, {
    method: 'POST',
    credentials: 'include',
  });
  await getJson<undefined>(res);
}

export async function getCurrentUser(): Promise<User> {
  const res = await fetch(`${base}/auth/me`, {
    credentials: 'include',
  });
  return getJson<User>(res);
}
